import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// indexdb
import { indexedDBStorage } from "@/storage/indexDBStorage.js";

import AuthState from "../components/login/states/auth.js";
import CompaniesState from "../components/dashboard/states/companies.js";
import TasksState from "../components/dashboard/states/tasks.js";
import MeetingsState from "../components/meetings/states/meetings.js";
import MessagesState from "../components/messages/states/messages.js";
import UserActivity from "@/components/user_activities/states";
import UsersState from "@/components/users/states";
import DocumentState from "@/components/documentsop/state";
import GoalState from "@/components/goals/state";
import TimeTrackState from "@/components/timetrack/state";
import LeaveStore from "@/components/profile/states";
import FeedbackState from "@/components/feedback/states";
import SettingsState from "@/components/settings/states";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: AuthState,
    companies: CompaniesState,
    tasks: TasksState,
    meetings: MeetingsState,
    messages: MessagesState,
    userActivity: UserActivity,
    users: UsersState,
    document: DocumentState,
    goal: GoalState,
    timetrack: TimeTrackState,
    leave: LeaveStore,
    feedback: FeedbackState,
    settings: SettingsState,
  },
  plugins: [
    createPersistedState({
      paths: [
        "auth",
        "companies.selected_company",
        "tasks.users",
        "tasks.priorities",
        "tasks.statuses",
        "tasks.userId",
        "tasks.tags",
        "settings",
      ],
      storage: window.localStorage,
    }),
    createPersistedState({
      paths: [
        "companies.companies",
        "goal",
        "tasks.assignedTasks",
        "tasks.personalTasks",
      ],
      storage: indexedDBStorage,
    }),
  ],
});
